export { default as ReceiptRefundOutlineIcon } from './ReceiptRefundOutlineIcon';
